import type { GetTerms200AllOfData } from './getTerms200AllOfData';

/**
 * 공통 API 응답 형식
 */
export type GetTerms200AllOf = {
  /**
   * 응답 데이터
   * @nullable
   */
  data?: GetTerms200AllOfData;
  /** 응답 메시지 */
  message: string;
  /** 요청 성공 여부 */
  success: boolean;
  /** 응답 시간 */
  timestamp?: string;
};
